import React, { useState, useRef } from 'react';
import TabBar from './tab_bar';
import Sponsors from './sponsors';
import AvailableSponsorships from './available_sponsorships';
import Guests from './guests';
import Info from './info';

const EventShowParent = ({
  likeProps,
  openForSponsorship,
  info,
  guests,
  sponsors,
  sponsorships,
  eventSlug,
  soldOut,
  previewOnly,
  proposedGuestsCount,
  userInternal,
  canManage,
  signedIn
}) => {
  const [tab, setTab] = useState('info');
  const infoRef = useRef();
  const guestsRef = useRef();
  const sponsorsRef = useRef();

  const guestsConditionals = () => {
  if (guests.guestCount === 0 && proposedGuestsCount > 0 && userInternal) {
      return <p className='t3 w3 text-center'>You have sent invitations to {proposedGuestsCount} {proposedGuestsCount === 1 ? 'person' : 'people'}. Once one confirms, they will be listed here.</p>;
    }
  };

  return (
    <>
      <div>
        <TabBar
          likeProps={likeProps}
          sponsors={sponsors}
          setTab={setTab}
          tab={tab}
          openForSponsorship={openForSponsorship}
          infoRef={infoRef}
          guestsRef={guestsRef}
          sponsorsRef={sponsorsRef}
          soldOut={soldOut}
          signedIn={signedIn}
        />
        <div className={`mt-20 mb-60 ${previewOnly ? 'preview-only' : ''}`}>
          <div className='tab-content' id='nav-tabsContent'>
            <Info info={info} infoRef={infoRef} />
            <Guests guests={guests} guestsRef={guestsRef} eventSlug={eventSlug} eventTitle={info.eventTitle} />
            {guestsConditionals()}
            {sponsors.length > 0 && (
              <Sponsors
                sponsors={sponsors}
                sponsorsRef={sponsorsRef}
              />
            )}
            {sponsorships.length > 0 && (
              <AvailableSponsorships
                sponsorships={sponsorships}
                eventSlug={eventSlug}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EventShowParent;
